import { FC } from "react";
import { Text, Button, Box } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../provider/AuthProvider";
import { BsDoorOpen } from "react-icons/bs";

const LogoutComponent: FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const logoutUser = () => {
    logout();
    navigate("/login");
  };

  return (
    <Box w="100%">
      <Button
        aria-label="Minha Conta"
        leftIcon={<BsDoorOpen size="20px" color="black" />}
        variant="tertiary"
        onClick={logoutUser}
      >
        <Text fontWeight="normal" color="black">
          Terminar sessão
        </Text>
      </Button>
    </Box>
  );
};

export default LogoutComponent;
